/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    Select,
    Checkbox,
    ListItemText,
    Modal,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";

import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import RejectReasonModal from "../../Modals/rejectReason";
import AddIcon from '@mui/icons-material/Add';
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import ReplayIcon from "@mui/icons-material/Replay";
import GetAppIcon from '@mui/icons-material/GetApp';
import IosShareIcon from '@mui/icons-material/IosShare';
import TagIcon from "@mui/icons-material/Tag";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import BlockIcon from "@mui/icons-material/Block";
import SendIcon from "@mui/icons-material/Send";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddTaskIcon from '@mui/icons-material/AddTask';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
} from "recharts";
import AddCommunications from "../../Modals/addcommunications";
import CreateTier from "../../Modals/createTier";
import ViewHealthScores from "../../Modals/viewHealthScores";
import SelectLoyaltyTier from "../../Modals/selectLoyaltyTier";
import CreateSegment from "../../Modals/createSegment";
import SwitchToggle from "../../components/SwitchToggle";
import CustomerHealthScore from "../../Modals/customerhealthscore";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}
const exportFields = [
    "Customer",
    "Contact",
    "Status",
    "Tier",
    "Orders",
    "LTV",
    "Health Score",
];

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ManageCustomers = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [valueTabs1, setValueTabs1] = useState(0);
    const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs1(newValue);
    };




    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };


    const handleClose = () => {
        setAnchorEl(null);
    };
    const [channelTab, setChannelTab] = useState(0);
    const handleChannelTab = (_: any, val: number) => setChannelTab(val);


    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
        setOpen(false);
    };
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    const [open2, setOpen2] = useState(false);
    const handleCloseModal2 = () => {
        setOpen2(false);
    };
    const [open3, setOpen3] = useState(false);
    const handleCloseModal3 = () => {
        setOpen3(false);
    };
    const [open4, setOpen4] = useState(false);
    const handleCloseModal4 = () => {
        setOpen4(false);
    };
    const [open5, setOpen5] = useState(false);
    const handleCloseModal5 = () => {
        setOpen5(false);
    };
    const [selectedComm, setSelectedComm] = useState<any>(null);
    const [openCommDetails, setOpenCommDetails] = useState(false);
    const handleCloseCommDetails = () => setOpenCommDetails(false);
    const communicationColumns = [
        "CHANNEL",
        "SUBJECT",
        "TYPE",
        "SEGMENT / AUDIENCE",
        "RECIPIENTS",
        "DELIVERED",
        "OPENED / CTR",
        "STATUS",
        "SENT AT",
        "ACTIONS",
    ];
    const communicationData = [
        {
            id: 1,
            channel: "Email",
            subject: "Exclusive Offer Just For You",
            type: "Campaign",
            segment: "Gold Members",
            recipients: 2300,
            delivered: 2210,
            failed: 90,
            opened: 740,
            clicked: 180,
            ctr: "24.3%",
            status: "sent",
            sentAt: "12/12/2025, 6:26:01 AM",
            consentIssues: 12,
            revenue: 0,
        },
        {
            id: 2,
            channel: "Push",
            subject: "We Miss You - 20% Off",
            type: "Campaign",
            segment: "Lapsed Customers",
            recipients: 1540,
            delivered: 1500,
            failed: 40,
            opened: 320,
            clicked: 45,
            ctr: "14.1%",
            status: "delivered",
            sentAt: "12/11/2025, 2:59:46 AM",
            consentIssues: 5,
            revenue: 0,
        },
        {
            id: 3,
            channel: "SMS",
            subject: "Order Confirmation",
            type: "Transactional",
            segment: "Order #8421",
            recipients: 1,
            delivered: 1,
            failed: 0,
            opened: 1,
            clicked: 0,
            ctr: "100%",
            status: "opened",
            sentAt: "12/10/2025, 10:47:11 AM",
            consentIssues: 0,
            revenue: 0,
        },
        {
            id: 4,
            channel: "Email",
            subject: "Cart Abandonment Reminder",
            type: "Transactional",
            segment: "Cart Abandoners",
            recipients: 120,
            delivered: 118,
            failed: 2,
            opened: 45,
            clicked: 12,
            ctr: "10.2%",
            status: "sent",
            sentAt: "12/09/2025, 4:15:22 PM",
            consentIssues: 2,
            revenue: 0,
        },
    ];

    const segmentData = [
        {
            title: "High-Value Customers",
            type: "Dynamic",
            description: "Customers with lifetime value > AED 5000",
            count: 850,
            status: "Active",
            icon: "💎",
        },
        {
            title: "Cart Abandoners",
            type: "Dynamic",
            description: "Customers with abandoned carts",
            count: 1540,
            status: "Active",
            icon: "🛒",
        },
        {
            title: "UAE Customers",
            type: "Static",
            description: "Customers based in UAE",
            count: 12500,
            status: "Active",
            icon: "🇦🇪",
        },
        {
            title: "Fashion Customers",
            type: "Dynamic",
            description: "Fashion category Customers",
            count: 5600,
            status: "Active",
            icon: "👗",
        },
        {
            title: "New Signups",
            type: "Dynamic",
            description: "Recently registered Customers",
            count: 890,
            status: "Active",
            icon: "✨",
        },
        {
            title: "Lapsed Customers",
            type: "Predictive",
            description: "Inactive Customers",
            count: 2300,
            status: "Active",
            icon: "⚠️",
        },
    ];



    const topCustomersData = [
        { name: "Sara Ahmed", amount: 18750, tier: "Platinum" },
        { name: "Faisal Hamad", amount: 16800, tier: "Platinum" },
        { name: "Mariam Yousef", amount: 14200, tier: "Gold" },
        { name: "Amina Farid", amount: 13500, tier: "Gold" },
    ];
    const tierData = [
        { name: "Gold", value: 44 },
        { name: "Silver", value: 36 },
        { name: "Bronze", value: 12 },
        { name: "Platinum", value: 8 },
    ];
    const COLORS = ["#d3b88c", "#cfcfcf", "#cd7f32", "#e5e4e2"];
    const customerColumns = [
        "CUSTOMER",
        "CONTACT",
        "STATUS",
        "VIP",
        "TIER",
        "ORDERS",
        "TOTAL SPENT",
        "LTV",
        "Health",
        "Churn Risk",
        "LAST ORDER",
        "PRIORITY STATE",
        "PRIORITY REASON",
        // "APPROVAL",
        "ACTIONS",
    ];
    const priorityCustomerColumns = [
        "CUSTOMER",
        "CONTACT",
        "STATUS",
        "VIP",
        "TIER",
        "ORDERS",
        "TOTAL SPENT",
        "LTV",
        "Health",
        "Churn Risk",
        "LAST ORDER",
        "PRIORITY STATE",
        "PRIORITY REASON",
        "ACTIONS",
    ];
    const vipCustomerColumns = [
        "CUSTOMER",
        "CONTACT",
        "STATUS",
        "TIER",
        "ORDERS",
        "TOTAL SPENT",
        "LTV",
        "Health",
        "Churn Risk",
        "LAST ORDER",
        "ACTIONS",
    ];
    const [customerData, setCustomerData] = useState([
        {
            id: "CUST-00025",
            name: "Maha Sultan",
            email: "maha.sultan@gmail.com",
            phone: "+971507677889",
            status: "Active",
            tier: "Gold",
            vipStatus: false,
            priorityState: "watch",
            priorityReason: "churn risk",
            health: 92.5,
            churnRisk: 15,
            orders: 11,
            totalSpent: "AED 7,800.00",
            ltv: "AED 8,600.00",
            lastOrder: "3 days ago",
        },
        {
            id: "CUST-00024",
            name: "Kareem Bashar",
            email: "kareem.bashar@hotmail.com",
            phone: "+971506566778",
            status: "Active",
            tier: "Silver",
            vipStatus: false,
            priorityState: "urgent",
            priorityReason: "pending",
            orders: 5,
            health: 70.5,
            churnRisk: 28,
            totalSpent: "AED 2,400.00",
            ltv: "AED 2,650.00",
            lastOrder: "5 days ago",
        },
        {
            id: "CUST-00023",
            name: "Samira Adnan",
            email: "samira.adnan@yahoo.com",
            phone: "+971505455667",
            status: "Inactive",
            tier: "Gold",
            vipStatus: false,
            priorityState: "urgent",
            priorityReason: "churn risk",
            orders: 9,
            health: 64.5,
            churnRisk: 42,
            totalSpent: "AED 6,100.00",
            ltv: "AED 6,750.00",
            lastOrder: "30 days ago",
        },
        {
            id: "CUST-00022",
            name: "Nader Qasim",
            email: "nader.qasim@gmail.com",
            phone: "+971504344556",
            status: "Active",
            tier: "Gold",
            vipStatus: true,
            priorityState: "watch",
            priorityReason: "complaint",
            orders: 13,
            health: 92.5,
            churnRisk: 8,
            totalSpent: "AED 9,800.00",
            ltv: "AED 10,800.00",
            lastOrder: "3 days ago",
        },
        {
            id: "CUST-00021",
            name: "Lina Zayed",
            email: "lina.zayed@outlook.com",
            phone: "+971503233445",
            status: "Active",
            tier: "Silver",
            vipStatus: false,
            priorityState: "urgent",
            priorityReason: "fraud",
            health: 100,
            churnRisk: 5,
            orders: 7,
            totalSpent: "AED 4,200.00",
            ltv: "AED 4,650.00",
            lastOrder: "3 days ago",
        },
        {
            id: "CUST-00020",
            name: "Walid Majid",
            email: "walid.majid@gmail.com",
            phone: "+971502122334",
            status: "Inactive",
            tier: "Bronze",
            vipStatus: false,
            priorityState: "watch",
            priorityReason: "churn risk",
            health: 40.5,
            churnRisk: 65,
            orders: 1,
            totalSpent: "AED 380.00",
            ltv: "AED 420.00",
            lastOrder: "3 days ago",
        },
    ]);
    const HealthBar = ({ value }: { value: number }) => {
        const color =
            value >= 85 ? "#22c55e" : value >= 70 ? "#f59e0b" : "#ef4444";

        return (
            <div className="health_bar">
                <span style={{ background: color, width: `${value}%` }} />
                <small>{value}</small>
            </div>
        );
    };
    const loyaltyData = [
        {
            name: "Bronze",
            level: "1",
            icon: "🥉",
            description:
                "Welcome to our loyalty program! Start earning points with every purchase.",
            pointsRange: "0 – 499",
            minSpend: "AED 0.00",
            discount: "5%",
            multiplier: "1x",
            benefits: [
                "5% off all purchases",
                "Earn 1 point per $1 spent",
                "100 bonus points on birthday",
            ],
        },
        {
            name: "Silver",
            level: "2",
            icon: "🥈",
            description:
                "Enjoy enhanced rewards and exclusive member-only offers.",
            pointsRange: "500 – 1,999",
            minSpend: "AED 250.00",
            discount: "10%",
            multiplier: "1.25x",
            benefits: [
                "10% off all purchases",
                "Earn 1.25 points per $1 spent",
                "Free shipping over $50",
                "Early access to sales",
            ],
        },
        {
            name: "Gold",
            level: "3",
            icon: "🥇",
            description:
                "Premium status with priority service and exclusive benefits.",
            pointsRange: "2,000 – 4,999",
            minSpend: "AED 1,000.00",
            discount: "15%",
            multiplier: "1.5x",
            benefits: [
                "15% off all purchases",
                "Free express shipping",
                "Priority support",
                "Invitation to exclusive events",
            ],
        },
        {
            name: "Platinum",
            level: "4",
            icon: "💎",
            description:
                "Elite tier with maximum rewards and personalized experiences.",
            pointsRange: "5,000 – 9,999",
            minSpend: "AED 2,500.00",
            discount: "20%",
            multiplier: "2x",
            benefits: [
                "20% off all purchases",
                "Dedicated account manager",
                "Extended returns",
                "VIP early launches",
            ],
        },
    ];
    const acquisitionData = [
        { label: "Referral", count: 4, percent: 16 },
        { label: "Social Media", count: 4, percent: 16 },
        { label: "Mobile App", count: 4, percent: 16 },
        { label: "Website", count: 9, percent: 36 },
        { label: "Marketplace", count: 2, percent: 8 },
        { label: "Walk In", count: 2, percent: 8 },
    ];

    const [selectedFields, setSelectedFields] = useState<string[]>([]);
    const exportFields = [
        "Customer",
        "Contact",
        "Age",
        "Gender",
        "Nationality",
        "Address",
        "Status",
        "Tier",
        "Orders",
        "Total Spent",
        "LTV",
        "Health",
        "Last Order",
    ];
    const bulkData = [
        {
            id: "CUS-001",
            name: "Ahmed Khan",
            email: "ahmed.khan@email.com",
            phone: "+971501234567",
            age: 32,
            gender: "Male",
            nationality: "UAE",
            address: "Dubai Marina, Dubai",
            status: "Active",
            tier: "Gold",
            orders: 46,
            totalSpent: "AED 18,450",
            ltv: "AED 24,000",
            health: 88,
            lastOrder: "06-01-2026",
        },
        {
            id: "CUS-002",
            name: "Sarah Williams",
            email: "sarah.williams@email.com",
            phone: "+971502345678",
            age: 29,
            gender: "Female",
            nationality: "UK",
            address: "Downtown Dubai",
            status: "Active",
            tier: "Platinum",
            orders: 72,
            totalSpent: "AED 35,600",
            ltv: "AED 48,200",
            health: 94,
            lastOrder: "10-01-2026",
        },
        {
            id: "CUS-003",
            name: "Rohan Mehta",
            email: "rohan.mehta@email.com",
            phone: "+971503456789",
            age: 37,
            gender: "Male",
            nationality: "India",
            address: "Business Bay, Dubai",
            status: "Under Review",
            tier: "Silver",
            orders: 18,
            totalSpent: "AED 5,200",
            ltv: "AED 8,000",
            health: 62,
            lastOrder: "18-12-2025",
        },
        {
            id: "CUS-004",
            name: "Aisha Al Mansoori",
            email: "aisha.m@email.com",
            phone: "+971504567890",
            age: 41,
            gender: "Female",
            nationality: "UAE",
            address: "Al Reem Island, Abu Dhabi",
            status: "Active",
            tier: "Gold",
            orders: 54,
            totalSpent: "AED 22,900",
            ltv: "AED 30,000",
            health: 90,
            lastOrder: "02-01-2026",
        },
        {
            id: "CUS-005",
            name: "Michael Chen",
            email: "michael.chen@email.com",
            phone: "+971505678901",
            age: 34,
            gender: "Male",
            nationality: "Singapore",
            address: "Jumeirah Lakes Towers, Dubai",
            status: "Probation",
            tier: "Bronze",
            orders: 9,
            totalSpent: "AED 2,150",
            ltv: "AED 4,500",
            health: 48,
            lastOrder: "22-11-2025",
        },
        {
            id: "CUS-006",
            name: "Fatima Noor",
            email: "fatima.noor@email.com",
            phone: "+971506789012",
            age: 26,
            gender: "Female",
            nationality: "Pakistan",
            address: "Al Nahda, Sharjah",
            status: "Active",
            tier: "Silver",
            orders: 21,
            totalSpent: "AED 7,800",
            ltv: "AED 12,000",
            health: 76,
            lastOrder: "04-01-2026",
        },
        {
            id: "CUS-007",
            name: "James Rodriguez",
            email: "james.rodriguez@email.com",
            phone: "+971507890123",
            age: 45,
            gender: "Male",
            nationality: "Spain",
            address: "Palm Jumeirah, Dubai",
            status: "Inactive",
            tier: "Gold",
            orders: 33,
            totalSpent: "AED 14,300",
            ltv: "AED 21,000",
            health: 55,
            lastOrder: "05-10-2025",
        },
        {
            id: "CUS-008",
            name: "Noor Hassan",
            email: "noor.h@email.com",
            phone: "+971508901234",
            age: 31,
            gender: "Female",
            nationality: "Egypt",
            address: "Mirdif, Dubai",
            status: "Active",
            tier: "Platinum",
            orders: 89,
            totalSpent: "AED 42,700",
            ltv: "AED 60,000",
            health: 97,
            lastOrder: "11-01-2026",
        },
    ];

    return (
        <>
            {/* Tabs Section */}
            <Box className="custom_tabs">
                <Tabs
                    value={valueTabs1}
                    onChange={handleChangeTabs1}
                    className="custom_tabs_links"
                >
                    <Tab label="All Customers" {...a11yProps(0)} />

                    <Tab label="Customer Segments" {...a11yProps(1)} />
                    <Tab label="Customer Analytics" {...a11yProps(2)} />
                    <Tab label="Customer Communications" {...a11yProps(3)} />
                    <Tab label="Loyalty Program" {...a11yProps(4)} />
                    <Tab label="VIP Customers" {...a11yProps(5)} />
                    <Tab label="Priority Customers" {...a11yProps(6)} />
                    <Tab label="Bulk Export" {...a11yProps(7)} />
                </Tabs>

            </Box>
            <CustomTabPanel value={valueTabs1} index={0}>
                <div className="main_title">
                    <h1>Manage Customers</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Customers
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* NEW VENDORS */}
                    <a href="/manage-customers?filter=new" className="cards">
                        <div className="data_top">
                            <h2>
                                56
                                <p>New Customers</p>
                            </h2>
                            <figure className="active_order">
                                <PersonAddAltIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ +12%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* ACTIVE VENDORS */}
                    <a href="/manage-customers?filter=active" className="cards">
                        <div className="data_top">
                            <h2>
                                1,120
                                <p>Active Customers</p>
                            </h2>
                            <figure className="sucess">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>84.0%</span>
                            <small>of total Customers</small>
                        </div>
                    </a>

                    {/* INACTIVE VENDORS */}
                    <a href="/manage-customers?filter=inactive" className="cards">
                        <div className="data_top">
                            <h2>
                                125
                                <p>Inactive Customers</p>
                            </h2>
                            <figure className="danger">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>▼ -6%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* PENDING APPROVAL */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                92
                                <p>Pending Approval Customers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>▲ +8%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* TOTAL VENDORS */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                1,301
                                <p>Total Customers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>100%</span>
                            <small>Customer base</small>
                        </div>
                    </a>

                </div>

                <div className="table_flex mt_20">
                    <div className="lt">
                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search customers..."
                                        />
                                    </Box>
                                    <div className="form">  <div className="control_group">
                                        <input type="date" />
                                    </div></div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn " variant="outlined"><IosShareIcon />Import</Button>
                                    <Button className="btn btn_primary" onClick={() => navigate("add-customer")}><AddIcon />Add Customer</Button>
                                </div>

                            </div>



                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {customerColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {customerData.map((customer) => (
                                            <TableRow key={customer.id} hover>
                                                <TableCell>
                                                    <b>{customer.name}</b>
                                                    <br />
                                                    <small>{customer.id}</small>
                                                </TableCell>

                                                <TableCell>
                                                    {customer.email}
                                                    <br />
                                                    <small>{customer.phone}</small>
                                                </TableCell>

                                                <TableCell>
                                                    <span
                                                        className={`status_chip ${customer.status === "Active" ? "active" : "inactive"
                                                            }`}>
                                                        {customer.status.toLowerCase()}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    {customer.vipStatus ? (
                                                        <span className="status_chip vip">VIP</span>
                                                    ) : (
                                                        <span style={{ color: "#999" }}>—</span>
                                                    )}
                                                </TableCell>

                                                <TableCell className="cr_pt" onClick={() => navigate(`view-tier/${customer.tier}`)}>
                                                    ⭐ {customer.tier}
                                                </TableCell>

                                                <TableCell>{customer.orders}</TableCell>

                                                <TableCell>{customer.totalSpent}</TableCell>

                                                <TableCell>{customer.ltv}</TableCell>
                                                <TableCell className="health_bar_score" onClick={() => setOpen3(true)}>
                                                    <HealthBar value={customer.health} />
                                                    <small>{customer.health}</small>
                                                </TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.churnRisk >= 50 ? "danger" : customer.churnRisk >= 30 ? "warning" : "info"}`}>
                                                        {customer.churnRisk}%
                                                    </span>
                                                </TableCell>
                                                <TableCell>{customer.lastOrder}</TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.priorityState === "urgent" ? "danger" : customer.priorityState === "watch" ? "warning" : "info"}`}>
                                                        {customer.priorityState}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.priorityReason === "fraud" ? "danger" : customer.priorityReason === "churn risk" ? "warning" : customer.priorityReason === "pending" ? "info" : "negative"}`}>
                                                        {customer.priorityReason}
                                                    </span>
                                                </TableCell>
                                                {/* <TableCell className="form">
                                                    <Select fullWidth size="small" defaultValue="Privacy">
                                                        <MenuItem value="Privacy">Pending</MenuItem>
                                                        <MenuItem value="Security">Approved</MenuItem>
                                                        <MenuItem value="Operational" onClick={() => setOpen2(true)}>Reject</MenuItem>
                                                    </Select>
                                                </TableCell> */}
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton onClick={() => navigate("view-customer")}>
                                                            <img src="/static/images/eye_icon.svg" alt="View" />
                                                        </IconButton>
                                                        <IconButton onClick={() => navigate("add-customer")}>
                                                            <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                        </IconButton>
                                                        <IconButton onClick={handleOpen}>
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        <Menu
                                                            anchorEl={anchorEl}
                                                            open={Boolean(anchorEl)}
                                                            onClose={handleClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                            className="table_menu"
                                                        >
                                                            <MenuItem onClick={handleClose}>
                                                                <ListItemIcon><MessageOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                Message Customer
                                                            </MenuItem>

                                                            <MenuItem onClick={() => navigate("customer-timeline")}>
                                                                <ListItemIcon><TimelineOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                View Timeline
                                                            </MenuItem>

                                                            <MenuItem onClick={handleClose}>
                                                                <ListItemIcon><FlagOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                Flag / Note
                                                            </MenuItem>

                                                            <MenuItem onClick={handleClose}>
                                                                <ListItemIcon><ReportOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                View Disputes / Refunds
                                                            </MenuItem>

                                                            <MenuItem onClick={handleClose}>
                                                                <ListItemIcon><StarOutlineOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                Mark as Priority Customer
                                                            </MenuItem>
                                                            <MenuItem onClick={handleClose}>
                                                                <ListItemIcon><StarOutlineOutlinedIcon fontSize="small" /></ListItemIcon>
                                                                Mark as VIP
                                                            </MenuItem>
                                                        </Menu>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>


                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
                <div className="main_title">
                    <h1>Customer Segments</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Customer Segments
                    </p>
                </div>


                <div className="stats_boxes gap_m">

                    {/* TOTAL VENDOR SEGMENTS */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                14
                                <p>Total Customer Segments</p>
                            </h2>
                            <figure className="blue">
                                <GpsFixedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>All segments</span>
                        </div>
                    </a>

                    {/* ACTIVE SEGMENTS */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                14
                                <p>Active Segments</p>
                            </h2>
                            <figure className="success">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>Currently in use</span>
                        </div>
                    </a>

                    {/* VENDORS SEGMENTED */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                23,718
                                <p>Customers Segmented</p>
                            </h2>
                            <figure className="warning">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>Total Customer</span>
                        </div>
                    </a>

                    {/* AVG SEGMENT SIZE */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                1,694
                                <p>Avg Segment Size</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight neutral">
                            <span>Customers per segment</span>
                        </div>
                    </a>

                </div>


                <div className="table_flex mt_20">
                    <div className="lt">
                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search..."
                                        />
                                    </Box>

                                </div>
                                <div className="right_s">
                                    <Button className="btn btn_primary" onClick={() => setOpen5(true)}><AddIcon />Create Segment </Button>
                                </div>
                            </div>
                            <div className="segments">
                                {segmentData.map((item, index) => (
                                    <div className="segment_card" key={index} onClick={() => navigate(`view-segment/${item.title.replace(/\s+/g, '-').toLowerCase()}`)}>
                                        <div className="card_header">
                                            <div className="icon">{item.icon}</div>
                                            <span className={`type ${item.type.toLowerCase()}`}>
                                                {item.type}
                                            </span>
                                        </div>

                                        <h4>{item.title}</h4>
                                        <p className="desc">{item.description}</p>

                                        <div className="card_footer">
                                            <span className="count">
                                                👥 {item.count.toLocaleString()}
                                            </span>

                                            <span className="status">{item.status}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
                <div className="main_title">
                    <h1>Customer Analytics</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Customer Analytics
                    </p>
                </div>


                <div className="stats_boxes gap_m">
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                25
                                <p>Total Customer</p>
                            </h2>
                            <figure className="blue">
                                <GpsFixedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>12.5% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                21
                                <p>Active Customer</p>
                            </h2>
                            <figure className="success">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>8.3% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                172,230.00 AED
                                <p>Total Revenue</p>
                            </h2>
                            <figure className="warning">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>15.2% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                6,889.20 AED
                                <p>Avg Customer LTV</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>6.7% increase</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                711.69 AED
                                <p>Avg Order Value</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>2.1% decrease</span>
                        </div>
                    </a>

                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                3
                                <p>New Customer (30d)</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>22.4% increase</span>
                        </div>
                    </a>
                </div>
                <div className="dashboard mt_20 cards">

                    <div className="top-customers">
                        <h2>Top Customer by Revenue</h2>
                        <ResponsiveContainer width="100%" height={260}>
                            <BarChart data={topCustomersData}>
                                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                <YAxis tick={{ fontSize: 12 }} />
                                <Tooltip
                                    formatter={(value) => `AED ${value.toLocaleString()}`}
                                />
                                <Bar
                                    dataKey="amount"
                                    fill="#d3b88c"
                                    radius={[8, 8, 0, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="loyalty-tier loyalty_donut_card">
                        <h2>Customer by Loyalty Tier</h2>
                        <ResponsiveContainer width="100%" height={260}>
                            <PieChart>
                                <Pie
                                    data={tierData}
                                    dataKey="value"
                                    nameKey="name"
                                    innerRadius={70}
                                    outerRadius={100}
                                    paddingAngle={4}
                                >
                                    {tierData.map((entry, index) => (
                                        <Cell key={index} fill={COLORS[index]} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(v) => `${v}%`} />
                            </PieChart>
                        </ResponsiveContainer>

                        {/* Legend */}
                        <div className="tier_legend">
                            {tierData.map((tier, index) => (
                                <div key={index} className="legend_item">
                                    <span
                                        className="dot"
                                        style={{ background: COLORS[index] }}
                                    />
                                    <span>{tier.name}</span>
                                    <b>{tier.value}%</b>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="analytics_grid mt_20">

                    {/* Acquisition Sources */}
                    <div className="cards analytics_card">
                        <h2>Acquisition Sources</h2>

                        {acquisitionData.map((item, i) => (
                            <div className="source_row" key={i}>
                                <div className="label_row">
                                    <span>{item.label}</span>
                                    <span>{item.count} ({item.percent}%)</span>
                                </div>

                                <div className="progress_bar">
                                    <span style={{ width: `${item.percent}%` }} />
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Customer Status */}
                    <div className="cards analytics_card">
                        <h2>Customer Status</h2>

                        <div className="status_grid">
                            <div className="status_box active">
                                <h3>21</h3>
                                <p>Active</p>
                                <small>84.0%</small>
                            </div>

                            <div className="status_box inactive">
                                <h3>2</h3>
                                <p>Inactive</p>
                                <small>8.0%</small>
                            </div>

                            <div className="status_box suspended">
                                <h3>1</h3>
                                <p>Suspended</p>
                                <small>4.0%</small>
                            </div>

                            <div className="status_box churned">
                                <h3>1</h3>
                                <p>Churned</p>
                                <small>4.0%</small>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Customer Insights */}
                <div className="cards mt_20 insights_row">
                    <div className="insight blue">
                        <h4>Repeat Purchase Rate</h4>
                        <h2>96.0%</h2>
                        <p>24 customers made repeat purchases</p>
                    </div>

                    <div className="insight green">
                        <h4>Marketing Consent Rate</h4>
                        <h2>80.0%</h2>
                        <p>20 customers opted in</p>
                    </div>

                    <div className="insight purple">
                        <h4>Avg Orders per Customer</h4>
                        <h2>9.7</h2>
                        <p>Across all customers</p>
                    </div>
                </div>

            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
                <div className="main_title">
                    <h1> Customer Communications</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Customer Communications
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* TOTAL SENT */}
                    <a href="#" className="cards">
                        <div className="data_top">
                            <h2>
                                25
                                <p>Total Sent</p>
                            </h2>
                            <figure className="blue">
                                <SendIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>All channels</span>
                            <small>emails, sms, push</small>
                        </div>
                    </a>

                    {/* EMAIL */}
                    <a href="#" className="cards">
                        <div className="data_top">
                            <h2>
                                1
                                <p>Email</p>
                            </h2>
                            <figure className="sucess">
                                <MailOutlineIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>Opened</span>
                            <small>email campaigns</small>
                        </div>
                    </a>

                    {/* SMS */}
                    <a href="#" className="cards">
                        <div className="data_top">
                            <h2>
                                12
                                <p>SMS</p>
                            </h2>
                            <figure className="warning">
                                <SmsOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>High reach</span>
                            <small>text messages</small>
                        </div>
                    </a>

                    {/* PUSH */}
                    <a href="#" className="cards">
                        <div className="data_top">
                            <h2>
                                9
                                <p>Push</p>
                            </h2>
                            <figure className="active_order">
                                <NotificationsNoneIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>App notifications</span>
                            <small>real-time alerts</small>
                        </div>
                    </a>

                    {/* DELIVERED */}
                    <a href="#" className="cards">
                        <div className="data_top">
                            <h2>
                                4
                                <p>Delivered</p>
                            </h2>
                            <figure className="sucess">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>Successfully sent</span>
                            <small>delivery confirmed</small>
                        </div>
                    </a>

                </div>

                <div className="table_flex mt_20">
                    <div className="lt">

                        <Box className="custom_tabs1">
                            <Tabs value={channelTab} onChange={handleChannelTab} className="custom_tabs_links">
                                <Tab label="All" />
                                <Tab label="Email" />
                                <Tab label="SMS" />
                                <Tab label="Push" />
                                <Tab label="In-App" />
                            </Tabs>
                        </Box>

                        <div className="cards mt_20">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search..."
                                        />
                                    </Box>
                                    <div className="form">
                                        <div className="control_group">
                                            <input type="date" />
                                        </div>
                                    </div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn btn_primary" onClick={() => setOpen1(true)}>Send Message</Button>
                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {communicationColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {communicationData.map((row) => (
                                            <TableRow key={row.id} hover>
                                                <TableCell>
                                                    {row.channel}
                                                </TableCell>

                                                <TableCell>
                                                    <b>{row.subject}</b>
                                                </TableCell>

                                                <TableCell>{row.type}</TableCell>

                                                <TableCell>{row.segment}</TableCell>

                                                <TableCell>{row.recipients.toLocaleString()}</TableCell>

                                                <TableCell>
                                                    <span className={`status_chip ${row.delivered / row.recipients >= 0.95 ? "active" : "warning"}`}>
                                                        {((row.delivered / row.recipients) * 100).toFixed(1)}%
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    <span className="info_label">
                                                        {row.ctr}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    <span className={`status_chip ${row.status}`}>
                                                        {row.status}
                                                    </span>
                                                </TableCell>

                                                <TableCell>{row.sentAt}</TableCell>

                                                <TableCell>
                                                    <Button
                                                        size="small"
                                                        variant="text"
                                                        startIcon={<TrendingUpIcon />}
                                                        onClick={() => {
                                                            setSelectedComm(row);
                                                            setOpenCommDetails(true);
                                                        }}
                                                    >
                                                        Drill-down
                                                    </Button>
                                                </TableCell>


                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>




                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>Communication Insights</h4>

                            <div className="ai_alert danger">
                                <span className="icon">📉</span>
                                <p>
                                    <b>Underperformed:</b> This campaign underperformed vs average
                                </p>
                            </div>

                            <div className="ai_alert positive">
                                <span className="icon">📱</span>
                                <p>
                                    <b>Channel Win:</b> SMS performed better than email for this segment
                                </p>
                            </div>

                            <div className="ai_alert info">
                                <span className="icon">💡</span>
                                <p>
                                    <b>Smart Action:</b> Recommended resend to non-openers
                                </p>
                            </div>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>Low ROI:</b> High spend, low return — suggest stopping
                                </p>
                            </div>

                            <small className="ai_update">
                                Real-time AI Analysis active
                            </small>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={4}>
                <div className="main_title">
                    <h1>Loyalty Programs</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Loyalty Programs
                    </p>
                </div>

                <div className="stats_boxes gap_m">

                    {/* TOTAL MEMBERS */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                2,847
                                <p>Total Members</p>
                            </h2>
                            <figure className="blue">
                                <GpsFixedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>+12% this month</span>
                        </div>
                    </a>

                    {/* POINTS ISSUED */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                847,293
                                <p>Points Issued</p>
                            </h2>
                            <figure className="success">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>+8% this month</span>
                        </div>
                    </a>

                    {/* POINTS REDEEMED */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                124,502
                                <p>Points Redeemed</p>
                            </h2>
                            <figure className="warning">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>15% redemption rate</span>
                        </div>
                    </a>

                    {/* ACTIVE TIERS */}
                    <a className="cards">
                        <div className="data_top">
                            <h2>
                                5
                                <p>Active Tiers</p>
                            </h2>
                            <figure className="info">
                                <TagIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight neutral">
                            <span>Currently live</span>
                        </div>
                    </a>

                </div>



                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards loyalty_wrapper">

                            {/* Search + Action */}
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search loyalty tiers..."
                                        />
                                    </Box>
                                </div>

                                <div className="right_s">
                                    <Button className="btn btn_primary" onClick={() => setOpen(true)}>
                                        <AddIcon /> Create Tier
                                    </Button>
                                </div>
                            </div>

                            {/* Loyalty Tier Cards */}
                            <div className="loyalty_cards">

                                {loyaltyData.map((tier, index) => (
                                    <div className={`loyalty_card ${tier.level.toLowerCase()}`} key={index} onClick={() => navigate(`view-tier/${tier.name}`)}>

                                        {/* Header */}
                                        <div className="card_top">
                                            <div className="tier_left">
                                                <div className="tier_icon">{tier.icon}</div>
                                                <div>
                                                    <h4>
                                                        {tier.name}
                                                        <span className="level">Level {tier.level}</span>
                                                    </h4>
                                                    <span className="status active">Active</span>
                                                </div>
                                            </div>

                                            <div className="actions">
                                                <IconButton size="small">
                                                    <img src="/static/images/edit2_icon.svg" />
                                                </IconButton>
                                                <IconButton size="small">
                                                    <img src="/static/images/trash2_icon.svg" />
                                                </IconButton>
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <p className="desc">{tier.description}</p>

                                        {/* Meta */}
                                        <div className="meta">
                                            <span><b>Points:</b> {tier.pointsRange}</span>
                                            <span><b>Min Spend:</b> {tier.minSpend}</span>
                                            <span><b>Discount:</b> {tier.discount}</span>
                                            <span><b>Multiplier:</b> {tier.multiplier}</span>
                                            <span><b>Loyalty Abuse Risk:</b> Low</span>
                                        </div>

                                        {/* Benefits */}
                                        <div className="benefits">
                                            {tier.benefits.map((benefit, i) => (
                                                <span className="benefit_chip" key={i}>
                                                    {benefit}
                                                </span>
                                            ))}
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>

            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={5}>
                <div className="main_title">
                    <h1>VIP Customers</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - VIP Customers
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* HIGH LTV CUSTOMERS */}
                    <a href="/manage-customers?filter=high-ltv" className="cards">
                        <div className="data_top">
                            <h2>
                                128
                                <p>High LTV Customers</p>
                            </h2>
                            <figure className="sucess">
                                <TrendingUpIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ 18%</span>
                            <small>above avg LTV</small>
                        </div>
                    </a>

                    {/* HIGH ORDER FREQUENCY */}
                    <a href="/manage-customers?filter=high-frequency" className="cards">
                        <div className="data_top">
                            <h2>
                                94
                                <p>High Order Frequency</p>
                            </h2>
                            <figure className="sucess">
                                <ReplayIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ 15%</span>
                            <small>repeat buyers</small>
                        </div>
                    </a>

                    {/* PLATINUM/GOLD TIER */}
                    <a href="/manage-customers?filter=premium-tier" className="cards">
                        <div className="data_top">
                            <h2>
                                156
                                <p>Platinum/Gold Tier</p>
                            </h2>
                            <figure className="warning">
                                <StarOutlineOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>52%</span>
                            <small>of total revenue</small>
                        </div>
                    </a>

                    {/* BRAND ADVOCATES */}
                    <a href="/manage-customers?filter=brand-advocates" className="cards">
                        <div className="data_top">
                            <h2>
                                67
                                <p>Brand Advocates</p>
                            </h2>
                            <figure className="blue">
                                <FlagOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>4.8★</span>
                            <small>avg rating given</small>
                        </div>
                    </a>

                </div>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search customers..."
                                        />
                                    </Box>
                                    <div className="form">  <div className="control_group">
                                        <input type="date" />
                                    </div></div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn " variant="outlined"><GetAppIcon />Export</Button>
                                    {/* <Button className="btn " variant="outlined"><AddTaskIcon />Bulk Approve</Button> */}

                                </div>

                            </div>



                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {vipCustomerColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {customerData.map((customer) => (
                                            <TableRow key={customer.id} hover>
                                                <TableCell>
                                                    <b>{customer.name}</b>
                                                    <br />
                                                    <small>{customer.id}</small>
                                                </TableCell>

                                                <TableCell>
                                                    {customer.email}
                                                    <br />
                                                    <small>{customer.phone}</small>
                                                </TableCell>

                                                <TableCell>
                                                    <span
                                                        className={`status_chip ${customer.status === "Active" ? "active" : "inactive"
                                                            }`}>
                                                        {customer.status.toLowerCase()}
                                                    </span>
                                                </TableCell>

                                                <TableCell className="cr_pt" onClick={() => navigate(`view-tier/${customer.tier}`)}>
                                                    ⭐ {customer.tier}
                                                </TableCell>

                                                <TableCell>{customer.orders}</TableCell>

                                                <TableCell>{customer.totalSpent}</TableCell>

                                                <TableCell>{customer.ltv}</TableCell>
                                                <TableCell className="health_bar_score" onClick={() => setOpen3(true)}>
                                                    <HealthBar value={customer.health} />
                                                    <small>{customer.health}</small>
                                                </TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.churnRisk >= 50 ? "danger" : customer.churnRisk >= 30 ? "warning" : "info"}`}>
                                                        {customer.churnRisk}%
                                                    </span>
                                                </TableCell>
                                                <TableCell>{customer.lastOrder}</TableCell>
                                                {/* <TableCell className="form">
                                                    <Select fullWidth size="small" defaultValue="Privacy">
                                                        <MenuItem value="Privacy">Pending</MenuItem>
                                                        <MenuItem value="Security">Approved</MenuItem>
                                                        <MenuItem value="Operational" onClick={() => setOpen2(true)}>Reject</MenuItem>
                                                    </Select>
                                                </TableCell> */}
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton onClick={() => navigate("view-customer")}>
                                                            <img src="/static/images/eye_icon.svg" alt="View" />
                                                        </IconButton>
                                                        <IconButton onClick={() => navigate("add-customer")}>
                                                            <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                        </IconButton>
                                                 
                                                       
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>


                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>

            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={6}>
                <div className="main_title">
                    <h1>Priority Customers</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Priority Customers
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* HIGH LTV BUT INACTIVE */}
                    <a href="/manage-customers?filter=high-ltv-inactive" className="cards">
                        <div className="data_top">
                            <h2>
                                32
                                <p>High LTV but Inactive</p>
                            </h2>
                            <figure className="danger">
                                <ScheduleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>⚠ Urgent</span>
                            <small>retention risk</small>
                        </div>
                    </a>

                    {/* REFUND DISPUTES */}
                    <a href="/manage-customers?filter=refund-disputes" className="cards">
                        <div className="data_top">
                            <h2>
                                18
                                <p>Refund Disputes</p>
                            </h2>
                            <figure className="warning">
                                <ReportOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>⚠ Review</span>
                            <small>manual action needed</small>
                        </div>
                    </a>

                    {/* FRAUD SIGNALS */}
                    <a href="/manage-customers?filter=fraud-signals" className="cards">
                        <div className="data_top">
                            <h2>
                                7
                                <p>Fraud Signals Detected</p>
                            </h2>
                            <figure className="danger">
                                <FlagOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>🚨 High Risk</span>
                            <small>immediate review</small>
                        </div>
                    </a>

                    {/* FAILED PAYMENTS */}
                    <a href="/manage-customers?filter=failed-payments" className="cards">
                        <div className="data_top">
                            <h2>
                                25
                                <p>Failed Payments</p>
                            </h2>
                            <figure className="blue">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>⚠ Action</span>
                            <small>payment retry needed</small>
                        </div>
                    </a>

                    {/* PENDING APPROVAL > SLA */}
                    <a href="/manage-customers?filter=pending-sla" className="cards">
                        <div className="data_top">
                            <h2>
                                12
                                <p>Pending Approval &gt; SLA</p>
                            </h2>
                            <figure className="warning">
                                <HourglassBottomIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>⚠ SLA Breach</span>
                            <small>urgent approval</small>
                        </div>
                    </a>

                    {/* NEGATIVE REVIEWS */}
                    <a href="/manage-customers?filter=negative-reviews" className="cards">
                        <div className="data_top">
                            <h2>
                                9
                                <p>Negative Reviews</p>
                            </h2>
                            <figure className="danger">
                                <MessageOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>⚠ Outreach</span>
                            <small>response needed</small>
                        </div>
                    </a>

                    {/* ABNORMAL BEHAVIOR */}
                    <a href="/manage-customers?filter=abnormal-behavior" className="cards">
                        <div className="data_top">
                            <h2>
                                14
                                <p>Abnormal Behavior (AI)</p>
                            </h2>
                            <figure className="info">
                                <TimelineOutlinedIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>🤖 AI Alert</span>
                            <small>pattern detected</small>
                        </div>
                    </a>

                </div>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search customers..."
                                        />
                                    </Box>
                                    <div className="form">  <div className="control_group">
                                        <input type="date" />
                                    </div></div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn " variant="outlined"><GetAppIcon />Export</Button>
                                    <Button className="btn " variant="outlined"><AddTaskIcon />Bulk Notify</Button>

                                </div>

                            </div>



                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {priorityCustomerColumns.map((col, i) => (
                                                <TableCell key={i}>{col}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {customerData.map((customer) => (
                                            <TableRow key={customer.id} hover>
                                                <TableCell>
                                                    <b>{customer.name}</b>
                                                    <br />
                                                    <small>{customer.id}</small>
                                                </TableCell>

                                                <TableCell>
                                                    {customer.email}
                                                    <br />
                                                    <small>{customer.phone}</small>
                                                </TableCell>

                                                <TableCell>
                                                    <span
                                                        className={`status_chip ${customer.status === "Active" ? "active" : "inactive"
                                                            }`}>
                                                        {customer.status.toLowerCase()}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    {customer.vipStatus ? (
                                                        <span className="status_chip vip">VIP</span>
                                                    ) : (
                                                        <span style={{ color: "#999" }}>—</span>
                                                    )}
                                                </TableCell>

                                                <TableCell className="cr_pt" onClick={() => navigate(`view-tier/${customer.tier}`)}>
                                                    ⭐ {customer.tier}
                                                </TableCell>

                                                <TableCell>{customer.orders}</TableCell>

                                                <TableCell>{customer.totalSpent}</TableCell>

                                                <TableCell>{customer.ltv}</TableCell>
                                                <TableCell className="health_bar_score" onClick={() => setOpen3(true)}>
                                                    <HealthBar value={customer.health} />
                                                    <small>{customer.health}</small>
                                                </TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.churnRisk >= 50 ? "danger" : customer.churnRisk >= 30 ? "warning" : "info"}`}>
                                                        {customer.churnRisk}%
                                                    </span>
                                                </TableCell>
                                                <TableCell>{customer.lastOrder}</TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.priorityState === "urgent" ? "danger" : customer.priorityState === "watch" ? "warning" : "info"}`}>
                                                        {customer.priorityState}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    <span className={`status_chip ${customer.priorityReason === "fraud" ? "danger" : customer.priorityReason === "churn risk" ? "warning" : customer.priorityReason === "pending" ? "info" : "negative"}`}>
                                                        {customer.priorityReason}
                                                    </span>
                                                </TableCell>
                                                {/* <TableCell className="form">
                                                    <Select fullWidth size="small" defaultValue="Privacy">
                                                        <MenuItem value="Privacy">Pending</MenuItem>
                                                        <MenuItem value="Security">Approved</MenuItem>
                                                        <MenuItem value="Operational" onClick={() => setOpen2(true)}>Reject</MenuItem>
                                                    </Select>
                                                </TableCell> */}
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <IconButton onClick={() => navigate("view-customer")}>
                                                            <img src="/static/images/eye_icon.svg" alt="View" />
                                                        </IconButton>
                                                        <IconButton onClick={() => navigate("add-customer")}>
                                                            <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                        </IconButton>
                                                     
                                                   
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>


                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>12 customers</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>7 fraud signals</b> detected in last 24h
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>Every hour</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#CUST-00022</h5>
                                        <p>High LTV customer inactive 45 days</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#CUST-00018</h5>
                                        <p>Fraud signal: unusual order pattern</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>

            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={7}>
                <div className="main_title d_flex">
                    <h1>Bulk Export Customers</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Bulk Export Customers
                    </p>
                </div>
                <div className="stats_boxes gap_m">

                    {/* NEW VENDORS */}
                    <a href="/manage-customers?filter=new" className="cards">
                        <div className="data_top">
                            <h2>
                                56
                                <p>New Customers</p>
                            </h2>
                            <figure className="active_order">
                                <PersonAddAltIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight positive">
                            <span>▲ +12%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* ACTIVE VENDORS */}
                    <a href="/manage-customers?filter=active" className="cards">
                        <div className="data_top">
                            <h2>
                                1,120
                                <p>Active Customers</p>
                            </h2>
                            <figure className="sucess">
                                <CheckCircleIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>84.0%</span>
                            <small>of total Customers</small>
                        </div>
                    </a>

                    {/* INACTIVE VENDORS */}
                    <a href="/manage-customers?filter=inactive" className="cards">
                        <div className="data_top">
                            <h2>
                                125
                                <p>Inactive Customers</p>
                            </h2>
                            <figure className="danger">
                                <BlockIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight negative">
                            <span>▼ -6%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* PENDING APPROVAL */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                92
                                <p>Pending Approval Customers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight warning">
                            <span>▲ +8%</span>
                            <small>from last month</small>
                        </div>
                    </a>

                    {/* TOTAL VENDORS */}
                    <a href="/manage-customers" className="cards">
                        <div className="data_top">
                            <h2>
                                1,301
                                <p>Total Customers</p>
                            </h2>
                            <figure className="blue">
                                <GroupsIcon fontSize="large" />
                            </figure>
                        </div>

                        <div className="ai_insight info">
                            <span>100%</span>
                            <small>Customer base</small>
                        </div>
                    </a>

                </div>


                <div className="cards mt_20">
                    <div className="table_header table_header_bulk form">
                        <h4>Enter Date Range -</h4>
                        <input type="date" />
                        <input type="date" />
                        <Select
                            fullWidth
                            size="small"
                            multiple
                            displayEmpty
                            value={selectedFields}
                            onChange={(e) => setSelectedFields(e.target.value as string[])}
                            renderValue={(selected) =>
                                selected.length === 0
                                    ? "Select Fields To Export"
                                    : selected.join(", ")
                            }
                        >
                            {exportFields.map((field) => (
                                <MenuItem key={field} value={field}>
                                    <Checkbox checked={selectedFields.indexOf(field) > -1} />
                                    <ListItemText primary={field} />
                                </MenuItem>
                            ))}
                        </Select>
                        <Button className="btn " variant="outlined"><GetAppIcon />Export</Button>



                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {exportFields.map((col, i) => (
                                        <TableCell key={i}>{col}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {bulkData.map((customer) => (
                                    <TableRow key={customer.id} hover>

                                        {/* CUSTOMER */}
                                        <TableCell>
                                            <strong>{customer.name}</strong>
                                        </TableCell>

                                        {/* CONTACT */}
                                        <TableCell>
                                            <div>
                                                <p>{customer.email}</p>
                                                <small>{customer.phone}</small>
                                            </div>
                                        </TableCell>

                                        {/* AGE */}
                                        <TableCell>{customer.age}</TableCell>

                                        {/* GENDER */}
                                        <TableCell>{customer.gender}</TableCell>

                                        {/* NATIONALITY */}
                                        <TableCell>{customer.nationality}</TableCell>

                                        {/* ADDRESS */}
                                        <TableCell className="truncate">
                                            {customer.address}
                                        </TableCell>

                                        {/* STATUS */}
                                        <TableCell>
                                            <span className={`status_chip ${customer.status.toLowerCase()}`}>
                                                {customer.status}
                                            </span>
                                        </TableCell>

                                        {/* TIER */}
                                        <TableCell>
                                            <span className={`tier_chip ${customer.tier.toLowerCase()}`}>
                                                {customer.tier}
                                            </span>
                                        </TableCell>

                                        {/* ORDERS */}
                                        <TableCell>{customer.orders}</TableCell>

                                        {/* TOTAL SPENT */}
                                        <TableCell>{customer.totalSpent}</TableCell>

                                        {/* LTV */}
                                        <TableCell>{customer.ltv}</TableCell>

                                        {/* HEALTH */}
                                        <TableCell>
                                            <HealthBar value={customer.health} />
                                        </TableCell>

                                        {/* LAST ORDER */}
                                        <TableCell>{customer.lastOrder}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>


                </div>


            </CustomTabPanel>
            <CommunicationDetails
                open={openCommDetails}
                onClose={handleCloseCommDetails}
                data={selectedComm}
            />
            <CreateTier open={open} onClose={handleCloseModal} setOpen={setOpen} />
            <RejectReasonModal open={open2} onClose={handleCloseModal2} setOpen={setOpen2} />
            <AddCommunications open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
            <CustomerHealthScore open={open3} onClose={handleCloseModal3} setOpen={setOpen3} />
            <SelectLoyaltyTier open={open4} onClose={handleCloseModal4} setOpen={setOpen4} />
            <CreateSegment open={open5} onClose={handleCloseModal5} setOpen={setOpen5} />
        </>
    );
};

const CommunicationDetails = ({ open, onClose, data }: { open: boolean, onClose: () => void, data: any }) => {
    if (!data) return null;

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Campaign Drill-down</h2>
                        <button className="btn-close" onClick={onClose}>
                            <CloseIcon />                        </button>
                    </div>

                    <div className="gap_p">
                        <div className="preview_box mt_20">
                            <h4>{data.subject}</h4>
                            <p><b>Channel:</b> {data.channel}</p>
                            <p><b>Type:</b> {data.type}</p>
                            <p><b>Sent At:</b> {data.sentAt}</p>
                        </div>

                        <div className="stats_grid mt_20">
                            <div className="insight blue">
                                <small>Sent</small>
                                <h3>{data.recipients.toLocaleString()}</h3>
                            </div>
                            <div className="insight green">
                                <small>Delivered</small>
                                <h3>{data.delivered.toLocaleString()}</h3>
                            </div>
                            <div className="insight red">
                                <small>Failed</small>
                                <h3>{data.failed.toLocaleString()}</h3>
                            </div>
                        </div>

                        <div className="stats_grid mt_10">
                            <div className="insight purple">
                                <small>Opened</small>
                                <h3>{data.opened.toLocaleString()}</h3>
                            </div>
                            <div className="insight info">
                                <small>Clicked</small>
                                <h3>{data.clicked.toLocaleString()}</h3>
                            </div>
                            <div className="insight warning">
                                <small>CTR</small>
                                <h3>{data.ctr}</h3>
                            </div>
                        </div>

                        <div className="preview_box mt_20">
                            <p><b>Segment used:</b> “{data.segment}”</p>
                            <p className="danger"><b>Consent issues:</b> {data.consentIssues} blocked</p>
                            <p className="success"><b>Revenue influenced:</b> AED {data.revenue} (Estimated)</p>
                        </div>
                    </div>

                    <div className="footer_btn_flex mt_20">
                        <Button className="btn btn_primary" onClick={onClose}>
                            Close Details
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ManageCustomers;
